import React from 'react';
import { Modal } from 'antd';
import s from './s.module.less';

type Props = {
    open: boolean;
    title: string;
    onClose: () => void;
    footer: React.ReactNode;
    children: React.ReactNode;
};

// 原型 .ibbw-confirm-modal：560 宽，标题 + 关闭，正文区滚动，底部右对齐按钮
export default function ConfirmModal({ open, title, onClose, footer, children }: Props) {
    return (
        <Modal
            open={open}
            title={title}
            onCancel={onClose}
            footer={<div className={s.foot}>{footer}</div>}
            width={560}
            centered
            destroyOnClose
            className={s.confirmModal}
        >
            <div className={s.body}>{children}</div>
        </Modal>
    );
}
